import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginService } from '@docpath/linces-angular-components/common';
import { mergeMap, Observable, of } from 'rxjs';
import { RoutingPath } from 'src/app/constants/routing-path';

import { CloudService } from '../services/cloud.service';

@Injectable({
    providedIn: 'root'
})
export class LoginGuard implements CanActivate {

    constructor(
        private readonly loginService: LoginService,
        private readonly cloudService: CloudService
    ) { }

    // eslint-disable-next-line sonarjs/function-return-type
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean {

        if (this.cloudService.isModeCloud()) {
            this.loginService.checkSessionByToken(
                this.cloudService.getAccessTokenCookie(),
                this.cloudService.getRefreshTokenCookie(),
                state.url,
                `/${RoutingPath.PATH_LOGIN}`
            ).pipe(
                mergeMap(returnCheckSession => {
                    this.cloudService.updateCookies();
                    return of(returnCheckSession);
                })
            );
        }

        return this.loginService.checkSession(state.url, `/${RoutingPath.PATH_LOGIN}`);

    }

}
